import { render, staticRenderFns } from "./qualiAftersale.vue?vue&type=template&id=e97fac68&scoped=true"
import script from "./qualiAftersale.vue?vue&type=script&lang=js"
export * from "./qualiAftersale.vue?vue&type=script&lang=js"
import style0 from "./qualiAftersale.vue?vue&type=style&index=0&id=e97fac68&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97fac68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e97fac68')) {
      api.createRecord('e97fac68', component.options)
    } else {
      api.reload('e97fac68', component.options)
    }
    module.hot.accept("./qualiAftersale.vue?vue&type=template&id=e97fac68&scoped=true", function () {
      api.rerender('e97fac68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/components/qualiAftersale.vue"
export default component.exports